/* eslint-disable react/no-danger */
/* eslint-disable no-confusing-arrow */
/* eslint-disable react/prop-types */
import { memo, useState } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isEmpty, isNull } from 'lodash';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Col, Form, Row } from 'react-bootstrap';

import { useCannabisLicenses } from '../../containers/searchCannabisLicenses/CannabisLicensesContext';
import CannabisLicenseHelper from '../../helpers/features/CannabisLicensesHelper';
import {
  checkMandotoryCannabisFeilds,
  checkMandotoryFeilds,
  cleanValues,
  isValidState,
} from '../../helpers/commonHelper';
import { StyleSteps } from '../styles/Page.styled';
import AppInput from '../common/input/AppInput';
import StyleForm from '../common/input/Form.styled';
import AppButton from '../styles/ButtonLink.styled';
import ThemeSelect from '../common/input/ThemeSelect';
import StateValueHelper from '../../helpers/stateHelper';

const { LICENSE_DETAILS, COMPANY_DETAILS } = CannabisLicenseHelper.ADD_NEW_LICENSES_FIELDS;

function CreateLicense() {
  const [clickNext, setClickNext] = useState(false);
  const [startDate, setStartDate] = useState({
    licIssueDate: '',
    licExpDate: '',
  });

  const initailValues = CannabisLicenseHelper.ADD_NEW_LICENSES_INITIAL;

  // const phoneRegExp = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  const licenseSchema = yup.object().shape({
    licNumber: yup.string().max(100, 'You have reached the character limit').nullable(true),
    companyLegal: yup.string().max(100, 'You have reached the character limit').nullable(true),
    companyDba: yup.string().max(100, 'You have reached the character limit').nullable(true),
    licIssuer: yup.string().max(100, 'You have reached the character limit').nullable(true),
    locStreet: yup.string().max(100, 'You have reached the character limit').nullable(true),
    locCity: yup
      .string()
      .matches(/^\D+$/g, 'Numbers are not allowed')
      .max(100, 'You have reached the character limit')
      .nullable(true),
    // state: yup
    //   .string()
    //   .matches(/^[A-Z]+$/g, 'Numbers, lowercase letters and special characters are not allowed')
    //   .test(
    //     'test-valid-state',
    //     'Invalid state name or value contains numbers, lowercase letters or special characters',
    //     value => isValidState(value),
    //   )
    //   .max(2, 'You have reached the character limit')
    //   .nullable(true),
    locZipCode: yup
      .string()
      .matches(/^[0-9-]+$/i, 'Invalid character incuded')
      .max(10, 'You have reached the character limit')
      .nullable(true),
    // country_code: yup
    //   .string()
    //   .matches(/^[A-Z]+$/g, 'Numbers, lowercase letters and special characters are not allowed')
    //   .max(2, 'You have reached the character limit')
    //   .nullable(true),
    // country_name: yup
    //   .string()
    //   .matches(/^\D+$/g, 'Numbers are not allowed')
    //   .max(100, 'You have reached the character limit')
    //   .nullable(true),
    licDesignation: yup.string().max(100, 'You have reached the character limit').nullable(true),
    licStatus: yup.string().max(100, 'You have reached the character limit').nullable(true),
    licType: yup.string().max(100, 'You have reached the character limit').nullable(true),
    licIssueDate: yup.string().max(100, 'You have reached the character limit').nullable(true),
    companyContact: yup.string().max(100, 'You have reached the character limit').nullable(true),
    locCounty: yup
      .string()
      .max(100, 'You have reached the character limit')
      .matches(/^\D+$/g, 'Numbers are not allowed')
      .nullable(true),
    companyWeb: yup.string().max(100, 'You have reached the character limit').nullable(true),
    companyEmail: yup
      .string()
      .email('Please check the format')
      .max(100, 'You have reached the character limit')
      .nullable(true),
    companyPhone: yup.string().max(9, 'You have reached the character limit').nullable(true),
    // note: yup.string().max(2000, 'You have reached the character limit').nullable(true),
    // status: yup.string().max(100, 'You have reached the character limit').nullable(true),
    licDetails: yup.string().max(500, 'You have reached the character limit').nullable(true),
    // state_name: yup.string().max(100, 'You have reached the character limit').nullable(true),
  });

  const license = useCannabisLicenses();

  const handleOnChange = () => {};
  const handleNextClick = () => {
    setClickNext(true);
  };

  const handleBackClick = () => {
    setClickNext(false);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initailValues}
      onSubmit={async values => {
        if (!checkMandotoryCannabisFeilds(values) && !license.isFormCancel) {
          license.openErrorAlert();
        } else if (checkMandotoryCannabisFeilds(values) && !license.isFormCancel) {
          license.handleAddNewLicense(cleanValues(values, ''));
        }
      }}
      validationSchema={licenseSchema}
    >
      {({
        values,
        errors,
        handleSubmit,
        handleChange,
        handleBlur,
        isValid,
        setFieldValue,
        dirty,
      }) => (
        <Form onSubmit={handleSubmit} onChange={handleOnChange} noValidate>
          <StyleSteps>
            <div className="sv-steps">
              <div className="v-line" />
              <div className="step-count">1</div>
              <div className="d-grid">
                <h3 className="mb-4">License Details</h3>
                <Row style={{ display: clickNext ? 'none' : '' }}>
                  {LICENSE_DETAILS.map(field => (
                    <InputFields
                      key={field.id}
                      field={field}
                      startDate={startDate}
                      setStartDate={setStartDate}
                      handleChange={handleChange}
                      values={values}
                      handleBlur={handleBlur}
                      errors={errors}
                      setFieldValue={setFieldValue}
                    />
                  ))}
                </Row>
                <div className="d-flex mt-2 gap-3 steps-buttons">
                  {!clickNext && (
                    <AppButton className="popup cancel" onClick={() => license.openCancelAlert()}>
                      {CannabisLicenseHelper.ADD_NEW_LICENSES_FORM_LICESEN_CANCEL}
                    </AppButton>
                  )}
                  {!clickNext && (
                    <AppButton fill className="d-block" onClick={() => handleNextClick()}>
                      {CannabisLicenseHelper.ADD_NEW_LICENSES_FORM_LICESEN_BUTTON_TEXT}
                    </AppButton>
                  )}
                </div>
              </div>
            </div>
            <div className="sv-steps">
              <div className="v-line second" />
              <div className="step-count">2</div>
              <div className="d-grid">
                <h3 className="mb-4">Company Details</h3>
                <div style={{ display: !clickNext ? 'none' : '' }}>
                  <Row>
                    {COMPANY_DETAILS.map(field => (
                      <InputFields
                        key={field.id}
                        field={field}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        handleChange={handleChange}
                        values={values}
                        handleBlur={handleBlur}
                        errors={errors}
                        setFieldValue={setFieldValue}
                      />
                    ))}
                  </Row>
                  <div className="d-flex mt-2 gap-3 steps-buttons">
                    {clickNext && (
                      <AppButton
                        type="button"
                        className="back-btn "
                        onClick={() => handleBackClick()}
                      >
                        {CannabisLicenseHelper.ADD_NEW_LICENSES_FORM_LICESEN_BACK_BUTTON_TEXT}
                      </AppButton>
                    )}
                    {clickNext && (
                      <AppButton fill className="d-block" type="submit">
                        {CannabisLicenseHelper.ADD_NEW_LICENSES_FORM_LICESEN_SUBMIT_BUTTON_TEXT}
                      </AppButton>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </StyleSteps>
        </Form>
      )}
    </Formik>
  );
}

const InputFields = ({
  field,
  startDate,
  setStartDate,
  handleChange,
  values,
  handleBlur,
  errors,
  setFieldValue,
}) => {
  const handleDateChange = date => {
    if (field.name === 'licExpDate') {
      setStartDate({
        ...startDate,
        licExpDate: isNull(date) ? '' : moment(date).format('YYYY/MM/DD'),
      });
    } else if (field.name === 'licIssueDate') {
      setStartDate({
        licExpDate: '',
        licIssueDate: isNull(date) ? '' : moment(date).format('YYYY/MM/DD'),
      });
      setFieldValue('licExpDate', '');
    }

    setFieldValue(field.name, isNull(date) ? '' : moment(date).format('YYYY/MM/DD'));
  };

  return (
    <Col md={3}>
      {field.type === 'text' && (
        <AppInput
          label={field.label}
          type={field.type}
          requied={field.required}
          placeholder={field.label}
          name={field.name}
          onChangeInput={handleChange}
          onBlurInput={handleBlur}
          value={values[field.name]}
          errorText={errors[field.name] ? errors[field.name] : null}
        />
      )}
      {field.type === 'select' && (
        <ThemeSelect
          label={field.label}
          placeholder={field.label}
          options={field.options}
          onChangeInput={val => {
            setFieldValue(field.name, val.value);
          }}
          errorText={errors[field.name] ? errors[field.name] : null}
          isSearchable={field.isSearchable}
          value={field.options.find(option => option.value === values.locStateCode)}
        />
      )}
      {field.type === 'date' && (
        <StyleForm>
          <Form.Group className="form-group">
            <label className="form-label" htmlFor="">
              {field.label}
            </label>
            <DatePicker
              className="form-control date-picker"
              format="MM/DD/YYYY"
              name={field.name}
              placeholderText={field.label}
              maxDate={field.name === 'licIssueDate' ? new Date() : ''}
              value={
                startDate[field.name] ? moment(startDate[field.name]).format('MM/DD/YYYY') : ''
              }
              selected={startDate[field.name] ? new Date(startDate[field.name]) : new Date()}
              minDate={
                field.name === 'licExpDate' && startDate.licIssueDate
                  ? new Date(startDate.licIssueDate)
                  : ''
              }
              onChange={date => handleDateChange(date)}
              onKeyDown={e => {
                e.preventDefault();
              }}
            />
            <Form.Text className="error-text">
              {errors[field.name] ? errors[field.name] : null}
            </Form.Text>
          </Form.Group>
        </StyleForm>
      )}
    </Col>
  );
};

export default memo(CreateLicense);
